import React from 'react'
import Header from '../landing/Header/Header'
import "./eror.scss"
import Footer from '../landing/footer/Footer'

const Error = () => {
    return (
        <>
                
            <section className='errormain'>
               
             
                <div className="custom-container ">
                    <div className="conterrormain">
                        <h3 className='errorh3'>Error 404 </h3>
                        <h2 className='errorh2'>Page not found</h2>
                        <p className='errorp'>Sorry, the page you were looking for does not exist, let's try to get you where you want to go.!
                        </p>
                        <button className='errobtn'>Go to Homepage</button>
                    </div>
                </div>
            </section>


        </>
    )
}

export default Error